import mapStyles from './billboard-map-styles.json';

(function($) {

  'use strict';

  const SELECTOR_NAV_CONTAINER = '.map-nav';
  const SELECTOR_NAV_MENU = '.map-nav ul';
  const SELECTOR_NAV_ITEM = '.map-nav li';
  const SELECTOR_NAV_SCROLL_LEFT = '.swiper-button-prev';
  const SELECTOR_NAV_SCROLL_RIGHT = '.swiper-button-next';
  const SELECTOR_DRAWER_CONTAINER = '.menu-hide';
  const SELECTOR_DRAWER_MENU = '.pin-pane';
  const SELECTOR_DRAWER_ITEM = '.pin-pane li';
  const SELECTOR_MAP = '#map';
  const SELECTOR_MAP_CONTAINER = '.map-container';
  const SELECTOR_MAP_LOADER = '.map-loader';

  const STATE_NAV_ITEM_ACTIVE = 'active';
  const STATE_DRAWER_ITEM_ACTIVE = 'active';
  const STATE_DRAWER_OPEN = 'show';
  const STATE_MAP_DRAWER_OPEN = 'menu-open';

  const RURAL = 'rural';
  const MAXFILTERZOOM = 14;

  const MARKER_PIN_IMG = '/wp-content/themes/directwest/images/GreenPin.png';

  const MAP_API_KEY = 'AIzaSyD8yWDHblrinqnCAeN2LuzPHGQPVge5X8E';

  var map;
  var infowindow;
  var markers = [];
  var initialBounds;

  function Billboard() {
    // PRIVATE
    const loadMap = function () {
      if ($(SELECTOR_MAP_CONTAINER).length) {
        const googleMapsScript = document.createElement('script');
        googleMapsScript.src = `https://maps.googleapis.com/maps/api/js?key=${MAP_API_KEY}&callback=initMap`;
        document.head.appendChild(googleMapsScript);
      }
    }

    const loadPins = function () {
      $.getJSON('/wp-json/wp/v2/map_pin?per_page=100', function (data) {
        $(SELECTOR_MAP_LOADER).hide();
        initPins(data);

        $(SELECTOR_NAV_ITEM).find('a').on('click', handleCitySelection);
      });
    }

    const initMap = function () {
      var mapOpts = {
        mapTypeId: google.maps.MapTypeId.TERRAIN,
        mapTypeControlOptions: {
          position: google.maps.ControlPosition.TOP_RIGHT,
        },
        fullscreenControlOptions: {
          position: google.maps.ControlPosition.TOP_RIGHT,
        },
        styles: mapStyles,
        options:{
          gestureHandling: 'greedy'
        }
      };

      map = new google.maps.Map(document.getElementById('map'), mapOpts);

      loadPins();

      infowindow = new google.maps.InfoWindow();
      infowindow.setOptions({maxWidth: 320});
    }

    const initPins = function (data) {
      initialBounds = new google.maps.LatLngBounds();

      data.forEach(function (markerData) {
        let markerAcf = markerData.acf;
        let markerLat = parseFloat(markerAcf.latitude);
        let markerLng = parseFloat(markerAcf.longitude);

        let point = new google.maps.LatLng(markerLat, markerLng);
        initialBounds.extend(point);

        let marker = new google.maps.Marker({
          position: {lat: markerLat, lng: markerLng},
          map: map,
          title: markerAcf.address,
          animation: google.maps.Animation.DROP,
          icon: MARKER_PIN_IMG,
        });

        let infowindowTitle = `<h3>${markerAcf.address}</h3>`;
        let infowindowFaces = ``;
        let infowindowLocation = ``;
        let infowindowPdf = ``;

        if (markerAcf.face_images) {
          let face1 = markerAcf.face_images[0];
          let face2 = markerAcf.face_images[1];

          infowindowFaces = `
            <div class="tabs">
              <input class="radiotab" name="tabs" tabindex="1" type="radio" id="tabone" checked="checked">
              <label class="label" for="tabone">${markerAcf.face_images.length > 0 ? face1.direction.label : ''}</label>
              <div class="panel" tabindex="1">
                ${markerAcf.face_images.length > 0 ? `<img src="${face1.image.sizes.medium}" />` : ''}
              </div>
              <input class="radiotab" tabindex="1" name="tabs" type="radio" id="tabtwo">
              <label class="label" for="tabtwo">${markerAcf.face_images.length > 1 ? face2.direction.label : ''}</label>
              <div class="panel" tabindex="1">
                ${markerAcf.face_images.length > 1 ? `<img src="${face2.image.sizes.medium}" />` : ''}
              </div>
            </div>
          `;
        }

        if (markerAcf.citytown && markerAcf.province) {
          let city = (markerAcf.citytown.value === RURAL) ? markerAcf.sidebar_label : markerAcf.citytown.label;
          let addressString = `${city}, ${markerAcf.province.label}`;
          infowindowLocation = `<li><strong>Market:</strong> <span>${addressString}</span></li>`;
        }

        if (markerAcf.photosheet && markerAcf.photosheet.file !== false) {
          let photosheetString = `<a href="${markerAcf.photosheet.file}" target="_blank">${markerAcf.photosheet.file_label}</a>`;
          infowindowPdf = `<li><strong>Billboard details:</strong> <span>${photosheetString}</span></li>`;
        }

        let infowindowContent = `
          <div class="infowindow">
            ${infowindowTitle}
            ${infowindowFaces}
            <div class="infowindow-details">
              <ul>
                ${infowindowLocation}
                ${infowindowPdf}
              </ul>
            </div>
          </div>
        `;

        google.maps.event.addListener(marker, 'click', function() {
          infowindow.setContent(getInfowindow(markerData.id));
          infowindow.open(map, this);
        });

        let pin = {
          id: markerData.id,
          title: markerAcf.address,
          city: markerAcf.citytown,
          sidebarLabel: markerAcf.sidebar_label,
          lat: markerLat,
          lng: markerLng,
          marker: marker,
          infowindow: infowindowContent,
        }

        markers.push(pin);
      });

      alphaPinSort();

      map.fitBounds(initialBounds);
    }

    const alphaPinSort = function () {
      markers.sort(function(a, b) {
        let aLabel = (a.city.value === RURAL) ? a.sidebarLabel : a.title;
        let bLabel = (b.city.value === RURAL) ? b.sidebarLabel : b.title;

        if(aLabel < bLabel) { return -1; }
        if(aLabel > bLabel) { return 1; }
        return 0;
      })
    }

    const initScrollButtons = function () {
      const swiper = new Swiper('.swiper', {
        slidesPerView: 'auto',
        navigation: {
          nextEl: SELECTOR_NAV_SCROLL_RIGHT,
          prevEl: SELECTOR_NAV_SCROLL_LEFT,
        },
      });
    }

    const enableMarkers = function (markerGroup) {
      let provBounds = new google.maps.LatLngBounds();

      markerGroup.forEach(function (marker) {
        marker.marker.setMap(map);

        let point = new google.maps.LatLng(marker.lat, marker.lng);
        provBounds.extend(point);
      });

      let mapDiv = $(SELECTOR_MAP);
      let mapDim = { height: mapDiv.height(), width: mapDiv.width() };
      let boundsZoom = getBoundsZoomLevel(provBounds, mapDim)

      if (boundsZoom > MAXFILTERZOOM)  {
        map.setZoom(MAXFILTERZOOM);
        map.panTo(provBounds.getCenter());
      } else {
        map.fitBounds(provBounds);
      }
    }

    const getBoundsZoomLevel = function (bounds, mapDim) {
      const WORLD_DIM = { height: 256, width: 256 };
      const ZOOM_MAX = 21;

      function latRad(lat) {
        let sin = Math.sin(lat * Math.PI / 180);
        let radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
        return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
      }

      function zoom(mapPx, worldPx, fraction) {
        return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
      }

      let ne = bounds.getNorthEast();
      let sw = bounds.getSouthWest();

      let latFraction = (latRad(ne.lat()) - latRad(sw.lat())) / Math.PI;

      let lngDiff = ne.lng() - sw.lng();
      let lngFraction = ((lngDiff < 0) ? (lngDiff + 360) : lngDiff) / 360;

      let latZoom = zoom(mapDim.height, WORLD_DIM.height, latFraction);
      let lngZoom = zoom(mapDim.width, WORLD_DIM.width, lngFraction);

      return Math.min(latZoom, lngZoom, ZOOM_MAX);
    }

    const disableMarkers = function (markerGroup) {
      markerGroup.forEach(function (marker) {
        marker.marker.setMap(null);
      });
    }

    const getInfowindow = function (id) {
      let [marker,] = markers.filter(function(pin) { return pin.id === id; });

      return marker.infowindow;
    }

    const closeDrawer = function () {
      $(SELECTOR_DRAWER_CONTAINER).removeClass(STATE_DRAWER_OPEN);
      $(SELECTOR_MAP_CONTAINER).removeClass(STATE_MAP_DRAWER_OPEN);
      $(SELECTOR_DRAWER_MENU).empty();

      enableMarkers(markers);
    }

    const openDrawer = function () {
      $(SELECTOR_DRAWER_CONTAINER).addClass(STATE_DRAWER_OPEN);
      $(SELECTOR_MAP_CONTAINER).addClass(STATE_MAP_DRAWER_OPEN);
      $(SELECTOR_DRAWER_MENU).empty();
    }

    const updateDrawerTitle = function (cityValue, cityTotal = 0) {
      $('.city-name').text(cityValue);
      $('.city-total').text(`${cityTotal} Location${cityTotal !== 1 ? 's' : ''}`);
    }

    const handleCitySelection = function (e) {
      e.preventDefault();
      $(this).parent().toggleClass(STATE_NAV_ITEM_ACTIVE).siblings().removeClass(STATE_NAV_ITEM_ACTIVE);

      if (infowindow) {
        infowindow.close();
      }

      if ($(SELECTOR_NAV_ITEM).hasClass(STATE_NAV_ITEM_ACTIVE)) {
        let cityValue = this.hash.substr(1);
        openDrawer(cityValue);

        let nonCityMarkers = markers.filter(function(pin) { return pin.city.value !== this; }, cityValue);
        disableMarkers(nonCityMarkers);

        let cityMarkers = markers.filter(function(pin) { return pin.city.value === this; }, cityValue);
        if (cityValue === RURAL) {
          enableMarkers(cityMarkers);
        }
        else {
          enableMarkers(cityMarkers);
        }

        updateDrawerTitle(cityMarkers[0].city.label, cityMarkers.length);

        cityMarkers.forEach(function (marker) {
          let label = (marker.city.value === RURAL) ? marker.sidebarLabel : marker.title;
          let $listLink = $(`<a href="#${marker.id}">${label}</a>`);
          $listLink.on('click', {locationId: marker.id}, handleDrawerSelection);

          let $listItem = $('<li />');
          $listItem.append($listLink);

          $(SELECTOR_DRAWER_MENU).append($listItem);
        });
      }
      else {
        closeDrawer();
      }
    }

    const handleDrawerSelection = function (event) {
      event.preventDefault();

      $(SELECTOR_DRAWER_ITEM).removeClass(STATE_DRAWER_ITEM_ACTIVE);
      $(SELECTOR_DRAWER_ITEM).find(`a[href="#${event.data.locationId}"]`).parent().addClass(STATE_DRAWER_ITEM_ACTIVE);

      let [marker,] = markers.filter(function(pin) { return pin.id === this; }, event.data.locationId);
      let latLng = new google.maps.LatLng(marker.lat, marker.lng);
      map.panTo(latLng);

      infowindow.setContent(getInfowindow(marker.id));
      infowindow.open(map, marker.marker);
    }

    // PUBLIC
    const init = function () {
      initMap();
      initScrollButtons();
    }

    return {
      loadMap: loadMap,
      init: init,
    }
  }

  Billboard().loadMap();

  window.initMap = function () {
    Billboard().init()
  };

})(jQuery);
